export const needsCurrencyFormatting = (input) => {
    return !Number.isNaN(Number(input));
};
